
export const axiosBaseHeadersConfig = {
  osVersion: "8",
  platform: "h5",
}

/*腾讯地图的key*/
export const tencentAmapKey = "ITWBZ-Y3Q3U-YFXVV-BASIU-VFJ7Q-3VBEZ"

/*基本信息*/

export const globalInfo = {
  seoWapUrl: process.env.VUE_APP_SEO_WAP_BASE_URL,
}
/*埋点code*/
export const POINT_CODE = {
  MARKET_TASK_AUTH_VISIT: "MARKET_TASK_AUTH_VISIT", //认证活动页面访问
  MARKET_TASK_INVITE_VISIT: "MARKET_TASK_INVITE_VISIT", //邀新活动页面访问
  SPREAD_PAGE: "SPREAD_PAGE", //营销推广页浏览次数埋点
  SPREAD_DOWNLOAD: "SPREAD_DOWNLOAD", //营销推广页下载埋点
  CASE_SQUARE_ACCESS_PAY_PAGE: "CASE_SQUARE_ACCESS_PAY_PAGE", //增值服务用户访问订单确认页
  CASE_SQUARE_ORDER_PAY_BUTTON: "CASE_SQUARE_ORDER_PAY_BUTTON", //增值服务订单确认页中支付按钮的点击
  COMMON_CONSULE_ACCESS_PAY_PAGE: "COMMON_CONSULE_ACCESS_PAY_PAGE", //增值服务访问订单确认页
  COMMON_CONSULE_PAY_BUTTON: "COMMON_CONSULE_PAY_BUTTON", //增值服务延长锁定订单确认页支付按钮的点击
  LS_SDCS_FWBXZTC_PAGE: "LS_SDCS_FWBXZTC_PAGE", //增值服务延长锁定次数订单确认页
  LS_SDCS_LJZF_BUTTON: "LS_SDCS_LJZF_BUTTON", //增值服务延长锁定次数支付成功页-立即支付按钮
  LS_SDCS_ZFCG_PAGE: "LS_SDCS_ZFCG_PAGE", //增值服务延长锁定次数支付成功页-整个页面
  DY_LLB_ALL_PAGE: "DY_LLB_ALL_PAGE", // 调研页面
  DY_LLB_GXQ_BUTTON:"DY_LLB_GXQ_BUTTON", // 感兴趣
  DY_LLB_BGXQ_BUTTON:"DY_LLB_BGXQ_BUTTON",// no感兴趣
  DHZX_ZFCGY_CKJD: "DHZX_ZFCGY_CKJD", // 支付成功页面-查看咨询进度
  DHZX_DHZX_ZFCGTC: "DHZX_DHZX_ZFCGTC", // 支付成功页面
  '1V1_TWZX_ZFCG_PAGE': "1V1_TWZX_ZFCG_PAGE", // 1V1图文咨询_支付成功
  '1V1_DHZX_ZFCG_PAGE': "1V1_DHZX_ZFCG_PAGE", // 1V1电话咨询_支付成功
  ZSFW_DHZX_DDQR_LJZX_BUTTON: 'ZSFW_DHZX_DDQR_LJZX_BUTTON', // 电话咨询订单确认页面_立即咨询钮
  '1V1_TWZX_LJZX_BUTTON':'1V1_TWZX_LJZX_BUTTON',	// 1V1图文咨询_立即咨询按钮	是	前端埋点	CK
  '1V1_DHZX_LJZX_BUTTON':'1V1_DHZX_LJZX_BUTTON',	// 1V1电话咨询_立即咨询按钮	是	前端埋点	CK
  LAW_PAGE_H5_INVITE_PAGE:"LAW_PAGE_H5_INVITE_PAGE",//邀请页进入人数(uv)
  LAW_PAGE_H5_USER_GET_CASE_BUTTON_CLICK:'LAW_PAGE_H5_USER_GET_CASE_BUTTON_CLICK',//点击立即获取案源成功提交人数
  LAW_PAGE_ACTIVE_PAGE:'LAW_PAGE_ACTIVE_PAGE',//注册成功页PV
  LAW_PAGE_ACTIVE_DOWNLOAD_APP_CLICK:'LAW_PAGE_ACTIVE_DOWNLOAD_APP_CLICK',//通过注册成功页下载APP人数
  LAW_GUIDE_BOTTOM_GET_CASE_CLICK:'LAW_GUIDE_BOTTOM_GET_CASE_CLICK',//底部悬浮按钮点击获取案源成功提交人数
  LAW_GUIDE_WECHAT_JOIN_CLICK:'LAW_GUIDE_WECHAT_JOIN_CLICK',//底部悬浮按钮点击微信合作提交人数
  LAW_GUIDE_ADD_SERVICE_WINDOW:'LAW_GUIDE_ADD_SERVICE_WINDOW',//邀请页面返回拦截弹窗
  LAW_GUIDE_SERVICE_WINDOW_CLICK:'LAW_GUIDE_SERVICE_WINDOW_CLICK',//邀请页面返回拦截弹窗确认按钮
  LAW_GUIDE_SERVICE_WINDOW_CLOSE_CLICK:'LAW_GUIDE_SERVICE_WINDOW_CLOSE_CLICK',//邀请页面返回拦截弹窗关闭按钮
}

/*埋点类型*/
export const BURY_POINT_TYPE = {
  PAGE: 1, //页面
  FRONTEVENT: 2, //前端事件
  BACKEND: 3, //后端业务埋点
}
/*埋点行为*/
export const BEHAVIOR = {
  VI: "VI", //曝光
  IN: "IN", //激活
  CK: "CK", //点击
}



/* 协议连接*/
export const protocols = {
  /* 隐私政策*/
  // law_privacy_protocol: 'https://protocol.imlaw.cn/law_privacy_protocol.html?header=0',
  law_privacy_protocol: `${process.env.VUE_APP_PROTOCOL_BASE_URL}/law_privacy_protocol.html?header=0`,
  /* 用户协议*/
  law_user_protocol: `${process.env.VUE_APP_PROTOCOL_BASE_URL}/law_user_protocol.html?header=0`,
  /* 购买协议*/
  law_buy_protocol: `${process.env.VUE_APP_PROTOCOL_BASE_URL}/law_buy_protocol.html?header=0`,
  /* 法临法律服务下单须知 */
  lawyer_order_notice: `${process.env.VUE_APP_PROTOCOL_BASE_URL}/lawyer_order_notice.html?header=0`,
  /* 增值服务协议 */
  lawyer_value_added_service_protocol: `${process.env.VUE_APP_PROTOCOL_BASE_URL}/lawyer-value-added-service-protocol.html?header=0`
}

/** lawsuitShare.7.0新的我的服务类型 */
export const newServiceCode = {
  /** 律师咨询 */
  LAWYERCONSULTATION: 100003,
  /** 案件委托 */
  ENTRUSTEDSERVICE: 100002,
  /** 极速咨询 */
  SPEEDCONSULTATION: 100001
}
/** lawsuitShare.7.0新的订单类型 */
export const newOrderType = {
  /** 律师咨询（付费卡片购买的）*/
  LAWYERCONSULTATION: 1001,
  /** 案件委托*/
  ENTRUSTEDSERVICE: 1002,
  /** 快速咨询（9.9元的拦截优惠价格）*/
  SPEEDCONSULTATION: 1001,
}
/* 支付类型 */
export const PAY_TYPE = {
  ALIPAY: 1,
  WECHAT: 2,
  HUIPAY: 10, // 上海汇付-支付宝
  HUIPAYWECHAT: 11, // 北京汇付宝-微信
}
